import React from "react";

const Loader = ({ inline = false, label = "Loading…" }) => (
  <div className={`loader${inline ? " loader--inline" : ""}`} role="status">
    <span className="spinner" />
    <span>{label}</span>
  </div>
);

export const PostSkeletons = ({ count = 6 }) => (
  <div className="post-grid" aria-hidden>
    {Array.from({ length: count }, (_, i) => (
      <div className="skeleton" key={i}>
        <div className="skeleton__media" />
        <div className="skeleton__line" />
        <div className="skeleton__line" />
      </div>
    ))}
  </div>
);

export default Loader;
